import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import {Observable} from 'rxjs'
import {takeUntil} from 'rxjs/operators'
import {HttpCancelService} from '@service/config/http-cancel.service'

@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
  private readonly httpCancelService = inject(HttpCancelService)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()))
  }
}
